import {Action} from '@ngrx/store';
import {PreviewPayload} from "@ispm-client/modules/bpmn-modeler/models/preview-payload";

export enum PreviewActionTypes {
  START_PREVIEW_PATHWAYS = '[Pathways] Start Preview',
}

export class StartPreviewPathways implements Action {
  readonly type = PreviewActionTypes.START_PREVIEW_PATHWAYS;
  constructor(public payload: PreviewPayload) { }
}


export type PreviewActions =
  StartPreviewPathways;
